import React, { useContext, useState } from 'react'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import { StoresContext } from '@App/contexts'

export interface RelinquishmentConfirmationPopupProps {
    onClose: () => void
}
const RelinquishmentConfirmationPopup = (props: RelinquishmentConfirmationPopupProps) => {
    const [hasConfirmed, setHasConfirmed] = useState(false)
    const { overclaimViewStore, popupStore, userStore } = useContext(StoresContext)
    const { onClose } = props

    const onCancel = () => {
        setHasConfirmed(false)
        onClose()
    }

    const onRelinquishShares = () => {
        overclaimViewStore
            .createOverclaimRelinquishment()
            .catch(() => {
                setHasConfirmed(false)
                popupStore.setAlertData('An error has occurred. Relinquishment was not successful.', true)
                onClose()
            })
            .finally(() => {
                overclaimViewStore.getRelinquishmentsForCurrentOverclaimViewItem().then((r) => setHasConfirmed(true))
            })
    }

    return (
        <Popup onClose={onClose}>
            {!hasConfirmed ? (
                <ConfirmationPopup
                    title="You are about to relinquish all of your shares on this work."
                    onCancel={onCancel}
                    cancelButtonText="Cancel"
                    onConfirm={onRelinquishShares}
                    confirmButtonText="Confirm"
                    disabled={userStore.userInfo.isInternal}
                >
                    {`By clicking "Confirm" below, you are confirming that 
                    you want to relinquish all of your current 
                    shares on this work and have the work removed from your catalog. 
                    Click "Cancel" to return to the overclaim detail page.`}
                </ConfirmationPopup>
            ) : (
                <ConfirmationPopup
                    title="Your shares on this work have been relinquished."
                    onConfirm={onClose}
                    confirmButtonText="Done"
                >
                    <span>
                        Your shares will be removed from this work and the work will be removed from your catalog within
                        approximately one business day. If you have relinquished your shares by mistake, please contact
                        us <a href="https://portal.themlc.com/contact-us"> here. </a>
                    </span>
                </ConfirmationPopup>
            )}
        </Popup>
    )
}

export default RelinquishmentConfirmationPopup
